import Header1 from "../app/common/header/header1";
import CandidateRoutes from "../routing/candidate-routes";
import SignUpPopup from "../app/common/popups/popup-signup";
import SignInPopup from "../app/common/popups/popup-signin";
import CanSidebarSection from "../app/pannels/candidate/sections/common/can-sidebar";
import InnerPageBanner from "../app/common/inner-page-banner";
import Footer1 from "../app/common/footer/footer1";
import { setBanner } from "../globals/banner-data";
import { Navigate, useLocation } from "react-router-dom";
import { getHeaderConfig } from "../globals/layout-config";
import { useAuth } from "../context/AuthContext";
import { admin, adminRoute, empRoute, employer, publicUser } from "../globals/route-names";
import AdminImpersonationBanner from "../app/common/admin-impersonation-banner";

function CandidateLayout() {
    const currentpath = useLocation().pathname;
    const { user, loading } = useAuth();

    if (loading) return <LoaderSafe />;
    if (!user) return <Navigate to={publicUser.pages.LOGIN} replace />;
    if (user.role === "admin") return <Navigate to={adminRoute(admin.DASHBOARD)} replace />;
    if (user.role !== "candidate") return <Navigate to={empRoute(employer.DASHBOARD)} replace />;

    return (
        <>
            <div className="page-wraper">

                <Header1 _config={getHeaderConfig(currentpath)} />
                <AdminImpersonationBanner />

                <div className="page-content">

                    <InnerPageBanner _data={setBanner(currentpath)} />

                    <div className="section-full p-t120  p-b90 site-bg-white">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-3 col-lg-4 col-md-12 rightSidebar m-b30">
                                    <div className="side-bar-st-1">
                                        <CanSidebarSection />
                                    </div>
                                </div>
                                <div className="col-xl-9 col-lg-8 col-md-12 m-b30">
                                    
                                    <CandidateRoutes />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <Footer1 />

                {/* BUTTON TOP START */}
                <button className="scroltop"><span className="fa fa-angle-up  relative" id="btn-vibrate" /></button>

                <SignUpPopup />
                <SignInPopup />

            </div>
        </>
    )
}

function LoaderSafe() {
    return <div className="p-a30 text-center">Loading account...</div>;
}

export default CandidateLayout;
